//@ts-nocheck
import { Fragment, useEffect, useState } from 'react'
import { Form, Nav, Tab } from "react-bootstrap";
import Select from 'react-select';
import MissionService from '../../../../service/MissionService';
import { useParams } from 'react-router';
import CustomToolTip from '../../../CommonComponents/CustomToolTip';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { toast } from 'react-toastify';
import OperateService from '../../../../service/OperateService';
import Loader from '../../../../Layouts/Loader/Loader';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import GroundStationService from '../../../../service/GroundStationService';
import CustomSelect from '../../../CommonComponents/CustomSelect';

const OrbitObject = [
    {
        label: 'Altitude',
        name: 'altitude',
        placeholder: 'Enter Altitude (km)',
        range: [300, 750]
    }, {
        label: 'Eccentricity',
        name: 'eccentricity',
        placeholder: 'Enter Eccentricity (degree)',
        range: [0, 1]
    }, {
        label: 'Inclination',
        name: 'inclination',
        placeholder: 'Enter Inclination (degree)',
        range: [0, 180]
    }, {
        label: 'Argument of periapsis',
        name: 'AP',
        placeholder: 'Enter periapsis (degree)',
        range: [0, 360]
    }, {
        label: 'True Anomaly',
        name: 'TA',
        placeholder: 'Enter Anomaly (degree)',
        range: [0, 360]
    }, {
        label: 'RAAN',
        name: 'RAAN',
        placeholder: 'Enter RAAN (degree)',
        range: [0, 360]
    },
]

interface OperateModalProps {
    close: () => void;
    navigate_to_operate: () => void;
    openModal?: any;
    hasSelectedSatellite?: any;
}

const OperateModal: React.FC<OperateModalProps> = ({ close, navigate_to_operate, openModal, hasSelectedSatellite }) => {

    const params = useParams();
    const { mission_name, mission_id } = params
    const [activeTabs, setActiveTabs] = useState('Details');
    const [satelliteOptions, setSatelliteOptions] = useState<any>([]);
    const [validation, setValidation] = useState(false);
    const [selectedType, setSelectedType] = useState('Orbit');
    const [selectedSatellite, setSelectedSatellite] = useState<any>(null);
    const [orbitParams, setOrbitParams] = useState({})
    const [mission, setMission] = useState({})
    const [gsList, setGsList] = useState([])
    const [selectGroundStation, setSelectGroundStation] = useState<any>([]);
    const [loading, setLoading] = useState(false)
    const [provider, setProvider] = useState({})


    const defaultOrbitParams = {
        'altitude': 450,
        'eccentricity': 0,
        'inclination': 98,
        'AP': 0,
        'TA': 0,
        'RAAN': 0,
        'epoch': dayjs.utc(new Date())
    }

    const get_latest_orbit_details = (sat_id: string) => {
        MissionService.getLatestOrbitDetails(sat_id, 'Launch').then((res) => {
            if (res.data) {
                const data = res.data
                const orbit_data = {
                    'altitude': data?.['OrbitParameters']?.['altitude'],
                    'eccentricity': data?.['OrbitParameters']?.['eccentricity'] ? data?.['OrbitParameters']?.['eccentricity'] : 0,
                    'inclination': data?.['OrbitParameters']?.['inclination'] ? data?.['OrbitParameters']?.['inclination'] : 0,
                    'AP': data?.['OrbitParameters']?.['AP'] ? data?.['OrbitParameters']?.['AP'] : 0,
                    'TA': data?.['OrbitParameters']?.['TA'] ? data?.['OrbitParameters']?.['TA'] : 0,
                    'RAAN': data?.['OrbitParameters']?.['RAAN'] ? data?.['OrbitParameters']?.['RAAN'] : 0,
                    'epoch': dayjs.utc(data?.['OrbitParameters']?.['epoch'] * 1000)
                }
                set_initial_orbit_params(selectedType, orbit_data)
            }
        }).catch((err) => {
            console.log(err);
            set_initial_orbit_params(selectedType, defaultOrbitParams)
        });
    }

    const get_satellites = () => {
        if (hasSelectedSatellite) {
            setSelectedSatellite({ label: hasSelectedSatellite?.['name'], value: hasSelectedSatellite })
            setSatelliteOptions([{ label: hasSelectedSatellite?.['name'], value: hasSelectedSatellite }])
            get_latest_orbit_details(hasSelectedSatellite?.['uniqueId']);
        } else {
            MissionService.get_satellites_by_mission_id(mission_id)?.then((res) => {
                if (res.data) {
                    let satellites: any = []
                    res.data.map(sat => {
                        if (!sat?.['promoted']) {
                            satellites.push({ label: sat?.['name'], value: sat })
                        }
                    })
                    setSatelliteOptions(satellites)
                }
            }).catch((err) => {
                console.error(err);
            })
        }
    }


    const fetchGroundStations = (mission_gsList) => {
        GroundStationService.getGroundStationsByMissionId()?.then((res) => {
            if (res.data) {
                let gs_list = res?.['data'].filter(gs => mission_gsList.includes(gs?.['groundStationId']))
                setGsList(gs_list)
            }
        }).catch((err) => {
            console.error(err);
        });
    };

    const get_mission = () => {
        MissionService.get_mission_by_id(mission_id)?.then((res) => {
            if (res.data) {
                setMission(res.data)
                if (res?.['data']?.['gsList'] && res?.['data']?.['gsList']?.length > 0) {
                    fetchGroundStations(res?.['data']?.['gsList'])
                }
            }
        }).catch((err) => {
            console.error(err);
        })
    }

    const set_initial_orbit_params = (orbit_type, data) => {
        if (orbit_type === 'Orbit') {
            setOrbitParams({
                'altitude': data?.['altitude'],
                'eccentricity': data?.['eccentricity'],
                'inclination': data?.['inclination'],
                'AP': data?.['AP'],
                'TA': data?.['TA'],
                'RAAN': data?.['RAAN'],
                'epoch': data?.['epoch']
            })
        } else if (orbit_type === 'TLE' || orbit_type === 'Norad ID') {
            setOrbitParams({
                [orbit_type === 'TLE' ? 'tle' : 'noradId']: ''
            })
        }
    }

    useEffect(() => {
        get_satellites()
    }, [])



    const handleCheck = (groundStationId: any) => {
        if (selectGroundStation.includes(groundStationId)) {
            let filter_gs = selectGroundStation.filter(gs => gs !== groundStationId)
            setSelectGroundStation(filter_gs)
        } else {
            setSelectGroundStation([...selectGroundStation, groundStationId])
        }
    };

    const handle_validate = () => {
        if (selectedType === 'Orbit') {
            const validated = OrbitObject.some(item => {
                if (item?.name === 'altitude') {
                    if ((orbitParams?.[item?.name] === '') || orbitParams?.[item?.name] < 300 || orbitParams?.[item?.name] > 750) {
                        toast.error((!orbitParams?.[item?.name] || (orbitParams?.[item?.name] && orbitParams?.[item?.name] === '')) ? item?.['label'] + " is required" : item?.['label'] + " should be between 300 and 750", { toastId: "o" })
                        return true;
                    }
                } else {
                    if (orbitParams?.[item?.name] === '') {
                        toast.error(item?.['label'] + " is required", { toastId: "o" })
                        return true;
                    }
                }
            });

            if (validated) {
                setValidation(true)
                return false
            } else {
                setValidation(false)
                return true
            }
        } else if (selectedType === 'TLE') {
            if (orbitParams?.['tle'] === '') {
                setValidation(true)
                toast.error("Tle is required.", { toastId: "o" })
                return false
            } else {
                setValidation(false)
                return true
            }
        } else if (selectedType === 'Norad ID') {
            if (orbitParams?.['noradId'] === '') {
                setValidation(true)
                toast.error("Norad ID is required.", { toastId: "o" })
                return false
            } else {
                setValidation(false)
                return true
            }
        }
    }
    const handle_submit = async () => {
        let validation = handle_validate()

        if (validation) {
            setLoading(true)
            let orbt_data = selectedType === 'Orbit' ? {
                orbitParameters: {
                    ...orbitParams,
                    epoch: Math.round(orbitParams?.['epoch']?.valueOf() / 1000)
                }
            } : {
                ...orbitParams
            }

            if (openModal?.type === 'promote') {
                try {
                    const satelliteId = selectedSatellite?.['value']?.['uniqueId'];
                    const resPromote = await OperateService.postPromoteSatellite(satelliteId, mission_id, orbt_data);

                    if (resPromote.data) {
                        const resProvider = await OperateService.getProvider(satelliteId);
                        setProvider(resProvider?.data);

                        let tcList = [];

                        Object.keys(resProvider?.data)?.forEach((item) => {
                            Object.keys(resProvider?.data?.[item])?.forEach((band) => {
                                tcList.push(
                                    {
                                        "timestamp": Math.floor(new Date().getTime()),
                                        "uniqueId": "Connect ID",
                                        "linkId": resProvider?.data?.[item]?.[band]?.['Downlink'],
                                        "operationType": 2
                                    },
                                    {
                                        "timestamp": Math.floor(new Date().getTime() + 10000),
                                        "uniqueId": "Connect ID",
                                        "linkId": resProvider?.data?.[item]?.[band]?.['Uplink'],
                                        "operationType": 2
                                    }
                                );
                            });
                        });

                        setLoading(false);
                        toast.success("Satellite promoted successfully", { toastId: "o" });
                        navigate_to_operate()
                        close();

                    }
                } catch (err) {
                    const errorMessage = err?.response?.data === 'Satellite is already in operate phase' ? err?.response?.data : "Something went wrong while promoting satellite";
                    toast.error(errorMessage, { toastId: "o" });
                    console.error(err);
                    setLoading(false);
                }
            }
        }
    }


    const handleScenarioDateTime = (dateTime) => {
        let year = new Date(dateTime).getFullYear()
        if (year < 2020 || year > 2027) {
            toast.error("Year must be between 2020 and 2027", { toastId: "error" });
            setOrbitParams({
                ...orbitParams,
                'epoch': dayjs.utc(new Date())
            })
        } else {
            setOrbitParams({
                ...orbitParams,
                'epoch': dayjs.utc(dateTime)
            })
        }
    }

    return (
        <Fragment>
            {loading && <Loader />}
            <div className="admin-form">
                <div className={'admin-form-card gap-3'}>
                    <div className='w-100 d-flex align-content-center justify-content-between'>
                        <span className='fs-23'>Promote Satellite</span>
                        <i onClick={close} className="fe fe-x-circle me-1 fs-25 cursor-pointer"></i>
                    </div>
                    <span className="w-100 border-top border-primary"></span>
                    <div style={{ background: 'rgba(255, 255, 255, 0.05)', borderRadius: '10px', padding: '20px' }}>
                        <div className={`d-flex flex-column gap-2 w-50 ${openModal?.type === 'update' ? 'opacity-50 pointer-events-none' : ''}`}>
                            <span className='fs-16'>Satellite</span>
                            <CustomSelect
                                isDisabled={openModal?.type === 'update'}
                                placeholder='Select Satellite' options={satelliteOptions}
                                value={selectedSatellite}
                                onChange={(e) => {
                                    setSelectedSatellite(e)
                                    get_latest_orbit_details(e?.value?.['uniqueId'])
                                }}
                            />
                        </div>
                        <div>
                            <Tab.Container id="left-tabs-example" activeKey={activeTabs}>
                                <div className='w-100 d-flex align-items-center justify-content-center'>
                                    <Nav
                                        variant="pills"
                                        className="panel-tabs nav-tabs w-auto d-flex justify-content-center"
                                    >
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey="Details"
                                                onClick={() => {
                                                    setActiveTabs("Details");
                                                }}
                                            >
                                                <svg
                                                    width="15"
                                                    height="16"
                                                    viewBox="0 0 15 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M11.1576 8C11.3698 8 11.5733 8.08429 11.7233 8.23432C11.8733 8.38435 11.9576 8.58783 11.9576 8.8V15.2C11.9576 15.6418 11.5994 16 11.1576 16C10.7158 16 10.3576 15.6418 10.3576 15.2V9.6H3.9576V15.2C3.9576 15.6418 3.59943 16 3.1576 16C2.71577 16 2.3576 15.6418 2.3576 15.2V8.8C2.3576 8.58783 2.44189 8.38435 2.59191 8.23432C2.74194 8.08429 2.94543 8 3.1576 8H11.1576ZM7.1576 11.2V12.8H5.5576V11.2H7.1576ZM7.1576 3.2C8.04915 3.19973 8.92316 3.44778 9.68166 3.91633C10.2121 4.24401 10.6714 4.67048 11.0361 5.17004C11.2967 5.52707 11.1315 6.01307 10.7361 6.21075C10.3407 6.40847 9.86617 6.2388 9.57684 5.90449C9.3655 5.66031 9.11742 5.44836 8.84014 5.27691C8.33448 4.96424 7.75172 4.79862 7.1572 4.79862C6.56268 4.79862 5.97992 4.96424 5.47426 5.27691C5.19693 5.44839 4.9488 5.66039 4.73744 5.90463C4.44822 6.23885 3.97382 6.40842 3.57853 6.21067C3.18345 6.01302 3.01841 5.52732 3.27882 5.17048C3.64351 4.67073 4.10293 4.24411 4.63354 3.91633C5.39204 3.44778 6.26605 3.19973 7.1576 3.2ZM7.1576 3.99547e-07C8.64346 -0.000320553 10.1 0.413172 11.3641 1.19414C12.4006 1.8345 13.2741 2.70118 13.9214 3.72512C14.1575 4.0986 13.9941 4.58185 13.5989 4.77954C13.2037 4.97728 12.7269 4.81357 12.4815 4.44602C11.9735 3.68524 11.3065 3.03949 10.523 2.5554C9.51167 1.93057 8.34635 1.59974 7.1576 1.6C5.96885 1.59974 4.80352 1.93057 3.79224 2.5554C3.00879 3.03946 2.34177 3.68515 1.83379 4.44587C1.58829 4.81352 1.11146 4.97733 0.716049 4.77962C0.320597 4.5819 0.157019 4.09836 0.393299 3.72466C1.04066 2.70081 1.91414 1.83421 2.95063 1.19393C4.21485 0.412954 5.67161 -0.000469162 7.1576 3.99547e-07Z"
                                                        fill="#EEEEEE"
                                                    />
                                                </svg>
                                                <span className='fs-16 fw-semibold ms-1'>Orbit Details</span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                disabled
                                                eventKey="Station"
                                                onClick={() => {
                                                    setActiveTabs("Station");
                                                }}
                                            >
                                                <svg
                                                    width="13"
                                                    height="16"
                                                    viewBox="0 0 13 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M9.354 7.854C9.44789 7.76011 9.50063 7.63278 9.50063 7.5C9.50063 7.36722 9.44789 7.23989 9.354 7.146C9.26011 7.05211 9.13278 6.99937 9 6.99937C8.86722 6.99937 8.73989 7.05211 8.646 7.146L5.5 10.293L4.354 9.146C4.30751 9.09951 4.25232 9.06264 4.19158 9.03748C4.13084 9.01232 4.06574 8.99937 4 8.99937C3.93426 8.99937 3.86916 9.01232 3.80842 9.03748C3.74768 9.06264 3.69249 9.09951 3.646 9.146C3.59951 9.19249 3.56264 9.24768 3.53748 9.30842C3.51232 9.36916 3.49937 9.43426 3.49937 9.5C3.49937 9.56574 3.51232 9.63084 3.53748 9.69158C3.56264 9.75232 3.59951 9.80751 3.646 9.854L5.146 11.354C5.19245 11.4006 5.24762 11.4375 5.30837 11.4627C5.36911 11.4879 5.43423 11.5009 5.5 11.5009C5.56577 11.5009 5.63089 11.4879 5.69163 11.4627C5.75238 11.4375 5.80755 11.4006 5.854 11.354L9.354 7.854ZM5 2.06237e-07C4.68967 -0.00016248 4.38694 0.0959278 4.13351 0.275028C3.88008 0.454129 3.68844 0.707422 3.585 1H2C1.60218 1 1.22064 1.15804 0.93934 1.43934C0.658035 1.72064 0.5 2.10218 0.5 2.5V14.5C0.5 14.8978 0.658035 15.2794 0.93934 15.5607C1.22064 15.842 1.60218 16 2 16H11C11.3978 16 11.7794 15.842 12.0607 15.5607C12.342 15.2794 12.5 14.8978 12.5 14.5V2.5C12.5 2.10218 12.342 1.72064 12.0607 1.43934C11.7794 1.15804 11.3978 1 11 1H9.415C9.31156 0.707422 9.11992 0.454129 8.86649 0.275028C8.61306 0.0959278 8.31033 -0.00016248 8 2.06237e-07H5ZM4.5 1.5C4.5 1.36739 4.55268 1.24022 4.64645 1.14645C4.74021 1.05268 4.86739 1 5 1H8C8.13261 1 8.25979 1.05268 8.35355 1.14645C8.44732 1.24022 8.5 1.36739 8.5 1.5C8.5 1.63261 8.44732 1.75979 8.35355 1.85355C8.25979 1.94732 8.13261 2 8 2H5C4.86739 2 4.74021 1.94732 4.64645 1.85355C4.55268 1.75979 4.5 1.63261 4.5 1.5ZM2 2H3.585C3.68844 2.29258 3.88008 2.54587 4.13351 2.72497C4.38694 2.90407 4.68967 3.00016 5 3H8C8.31033 3.00016 8.61306 2.90407 8.86649 2.72497C9.11992 2.54587 9.31156 2.29258 9.415 2H11C11.1326 2 11.2598 2.05268 11.3536 2.14645C11.4473 2.24022 11.5 2.36739 11.5 2.5V14.5C11.5 14.6326 11.4473 14.7598 11.3536 14.8536C11.2598 14.9473 11.1326 15 11 15H2C1.86739 15 1.74021 14.9473 1.64645 14.8536C1.55268 14.7598 1.5 14.6326 1.5 14.5V2.5C1.5 2.36739 1.55268 2.24022 1.64645 2.14645C1.74021 2.05268 1.86739 2 2 2Z"
                                                        fill="#CCF54E"
                                                    />
                                                </svg>
                                                <span className='fs-16 fw-semibold ms-1'>Ground Station</span>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <Tab.Content>
                                    <Tab.Pane eventKey="Details">
                                        <Form validated={validation} className='d-flex flex-column gap-3'>
                                            <div className='d-flex flex-column gap-0 w-60'>
                                                <span className='fs-16'>Select Type</span>
                                                <RadioGroup
                                                    className='mt-0 p-0'
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    value={selectedType}
                                                    onKeyDown={(e) => {
                                                        if (e.keyCode === 13) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        if (openModal?.type === 'promote') {
                                                            set_initial_orbit_params(e.target.value, mission)
                                                        }
                                                        setSelectedType(e.target.value)
                                                    }}
                                                >
                                                    {['TLE', 'Norad ID', 'Orbit'].map((item) => (
                                                        <FormControlLabel
                                                            disabled={item === 'TLE' || item === 'Norad ID'}
                                                            key={item}
                                                            value={item}
                                                            control={<Radio />}
                                                            label={item}
                                                            sx={{
                                                                ".MuiButtonBase-root": {
                                                                    backgroundColor: "transparent",
                                                                },
                                                                "&.Mui-checked": {
                                                                    backgroundColor: "gray",
                                                                },
                                                                ".MuiFormControlLabel-label.Mui-disabled": {
                                                                    color: "#F0F0F0", // Change this color value as needed
                                                                    opacity: 0.6, // Change this opacity value as needed
                                                                },
                                                                ".MuiRadio-root.Mui-disabled": {
                                                                    color: "#F0F0F0", // Change this color value for the radio button itself
                                                                    opacity: 0.6,
                                                                }
                                                            }}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </div>
                                            {selectedType === 'Orbit' &&
                                                <div className='d-flex flex-column w-50 gap-2'>
                                                    <span className='form-content-text text-nowrap'>Epoch</span>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                                        <DateTimePicker className='w-98' ampm={false} format='YYYY-MM-DD HH:mm:ss'
                                                            shouldDisableYear={(date) => ![2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027].includes(date?.['$y'])}
                                                            views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                                                            value={orbitParams?.['epoch']} onChange={handleScenarioDateTime} />
                                                    </LocalizationProvider>
                                                </div>
                                            }
                                            {selectedType === 'Orbit' && <div className='d-flex flex-wrap w-100 pop-scroll p-0 pe-2 overflow-y-auto gap-4'>
                                                {OrbitObject.map((item, index) => (
                                                    <div key={index} className={`d-flex flex-column gap-2 w-30`}>
                                                        <span className="form-content-text text-nowrap">{item.label}</span>
                                                        <div className={`d-flex gap-2 flex-column w-100 ${(openModal?.type === 'update' && (orbitParams?.['tle'] || orbitParams?.['noradId'])) ? 'opacity-50' : 'opacity-100'}`}>
                                                            <Form.Control
                                                                className="w-100"
                                                                min={item?.range?.[0]}
                                                                max={item?.range?.[1]}
                                                                disabled={(openModal?.type === 'update' && (orbitParams?.['tle'] || orbitParams?.['noradId']))}
                                                                required
                                                                type="number"
                                                                step={'any'}
                                                                placeholder={item.placeholder}
                                                                value={orbitParams?.[item.name]}
                                                                onChange={(event: any) => {
                                                                    if (event.target.value?.length <= 10) {
                                                                        if (item?.name !== 'altitude') {
                                                                            if (!isNaN(event.target.value) && +event.target.value >= item?.range?.[0] && +event.target.value <= item?.range?.[1]) {
                                                                                setOrbitParams({
                                                                                    ...orbitParams,
                                                                                    [item.name]: event.target.value !== '' ? +event.target.value : ''
                                                                                })
                                                                            } else {
                                                                                toast.error(`${item.label} should be between ${item?.range?.[0]} and ${item?.range?.[1]}.`, { toastId: 'o' })
                                                                            }
                                                                        } else {
                                                                            setOrbitParams({
                                                                                ...orbitParams,
                                                                                [item.name]: event.target.value !== '' ? +event.target.value : ''
                                                                            })
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {!orbitParams?.[item.name] ? `${item.label} is required.` : `${item.label} should be between ${item?.range?.[0]} and ${item?.range?.[1]}.`}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>}
                                            {selectedType === 'TLE' &&
                                                <div className="d-flex flex-column gap-2 w-100">
                                                    <span className="form-content-text text-nowrap">TLE</span>
                                                    <Form.Control
                                                        className="w-100"
                                                        required
                                                        as='textarea'
                                                        type="text"
                                                        placeholder="Enter TLE"
                                                        value={orbitParams?.['tle']}
                                                        onChange={(event) => {
                                                            setOrbitParams({
                                                                ...orbitParams,
                                                                'tle': event.target.value?.trimStart()
                                                            })
                                                        }}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid TLE.
                                                    </Form.Control.Feedback>
                                                </div>
                                            }
                                            {selectedType === 'Norad ID' &&
                                                <div className="d-flex flex-column gap-2 w-100">
                                                    <span className="form-content-text text-nowrap">Norad ID</span>
                                                    <div className="d-flex gap-2 flex-column w-50">
                                                        <Form.Control
                                                            className="w-100"
                                                            required
                                                            type="text"
                                                            placeholder="Enter Norad ID"
                                                            value={orbitParams?.['noradId']}
                                                            onChange={(event) => {
                                                                setOrbitParams({
                                                                    ...orbitParams,
                                                                    'noradId': event.target.value?.trimStart()
                                                                })
                                                            }}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please provide a valid Norad ID.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                            }
                                        </Form>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="Station" className='w-100'>
                                        {gsList?.length > 0 &&
                                            <div className='d-flex flex-column gap-3 w-100 pop-scroll-xs ps-0 pe-2 overflow-y-scroll'>
                                                <div className='d-flex w-100 align-items-center border rounded-3 py-3 px-5 justify-content-between '>
                                                    <span className='fs-16 w-5 mb-1 align-items-center justify-content-center d-flex color-table-header-text cursor-pointer'>
                                                        <CustomToolTip
                                                            title={selectGroundStation?.length === gsList?.length ? 'Remove all' : 'Select all'}
                                                            placement='top'
                                                        >
                                                            <Form.Check checked={selectGroundStation?.length === gsList?.length} className="cursor-pointer" type="checkbox"
                                                                onChange={() => {
                                                                    if (selectGroundStation?.length !== gsList?.length) {
                                                                        let all_gs = gsList.map(gs => {
                                                                            return gs?.['groundStationId']
                                                                        })
                                                                        setSelectGroundStation(all_gs)
                                                                    } else {
                                                                        setSelectGroundStation([])
                                                                    }
                                                                }}
                                                            />
                                                        </CustomToolTip>
                                                    </span>
                                                    <span className='fs-16 w-25 align-items-center justify-content-start d-flex color-table-header-text'>GROUND STATIONS</span>
                                                    <span className='fs-16 w-50 d-flex color-table-header-text align-items-center justify-content-start'>LOCATION</span>
                                                    <span className='fs-16 w-20 d-flex color-table-header-text align-items-center justify-content-start'>FREQUENCY BANDS</span>
                                                </div>

                                                {gsList && gsList.map((item: any, i) => {
                                                    return (
                                                        <div key={i} className='d-flex w-100 align-items-center rounded-3 py-4 px-5 justify-content-between session-history cursor-pointer' >
                                                            <span className='fs-16 w-5 align-items-center justify-content-center d-flex color-text cursor-pointer mb-1' onClick={(e) => { e.stopPropagation() }}>
                                                                <CustomToolTip
                                                                    title={item.groundStationName}
                                                                    placement='top'
                                                                >
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        className="h-5 cursor-pointer"
                                                                        checked={selectGroundStation.includes(item?.["groundStationId"])}
                                                                        onKeyDown={(e) => {
                                                                            if (e.keyCode === 13) {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                        onChange={() => {
                                                                            handleCheck(item["groundStationId"])
                                                                        }}
                                                                    />
                                                                </CustomToolTip>
                                                            </span>
                                                            <span className="w-25 fs-16 d-flex color-text align-items-center justify-content-start text-capitalize">
                                                                <span className='w-95 text-truncate'>{item?.['groundStationName']}</span>
                                                            </span>
                                                            <div className='d-flex flex-column w-50 align-items-start justify-content-start'>
                                                                <span className='color_history d-flex w-100'>
                                                                    <span className="w-20 color_history">Location :</span>
                                                                    <span className='color-location d-flex gap-1 w-70 text-capitalize fs-16'>
                                                                        <span className="text-truncate w-auto">{item?.properties?.['location']},</span>
                                                                        <span className="text-truncate w-auto">{item?.properties?.country?.includes(',') ? item?.properties?.country.split(",")[1] : item?.properties?.country}</span>
                                                                    </span>
                                                                </span>
                                                                <div className='d-flex gap-2 '>
                                                                    <span className='color_history'>Lat: <span className='color-text'>{item?.properties?.['latitude']}</span></span>
                                                                    <span className='color_history'>|</span>
                                                                    <span className='color_history'>Long: <span className='color-text'>{item?.properties?.['longitude']}</span></span>
                                                                </div>
                                                            </div>
                                                            <span className='fs-14 w-20 d-flex color-text align-items-center justify-content-start'>{
                                                                (item?.['properties']?.['freqbands'] && item?.['properties']?.['freqbands'].length > 0) &&
                                                                item?.['properties']?.['freqbands'].map((band, i) => `${band} ${i === item?.['properties']?.['freqbands'].length - 1 ? '' : '| '}`)}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        }
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>

                    <span className="w-100 border-top border-primary"></span>
                    <div className="n-modal-footer gap-3">
                        <div className="n-footer-buttons">
                            <button className="btn btn-outline-danger" onClick={close}>
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    if (selectedType === 'Orbit') {
                                        try {
                                            if (selectedSatellite && orbitParams?.['epoch'].toISOString().split('Z')) {
                                                handle_submit()
                                            } else {
                                                toast.error('Please select a satellite', { toastId: 'select_satellite' })
                                            }
                                        } catch (err) {
                                            toast.error('Please enter a valid date', { toastId: 'select_satellite' })
                                        }
                                    } else {
                                        if (selectedSatellite) {
                                            handle_submit()
                                        } else {
                                            toast.error('Please select a satellite', { toastId: 'select_satellite' })
                                        }
                                    }
                                }}
                            >
                                {openModal?.type === 'promote' ? 'Promote Satellite' : 'Update'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default OperateModal